import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import Error from "../utils/Error";
import Loader from "../utils/Loader";
import { formatDisplayDate } from "../utils/fomatDate";
import { useBlogs, useSearchBlogs } from "../../hooks/useBlog";
import ImageWithSkeleton from "../utils/imgSkeleton";
import he from "he";
import { useQueryClient } from "@tanstack/react-query";
const Blog2 = () => {
  const { data: blog, isLoading, error, refetch } = useBlogs();
  const { data: searchBlogs, isFetching } = useSearchBlogs();
  const blogs = searchBlogs?.data?.length>0 ? searchBlogs : blog;
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.removeQueries(["one"]);
    refetch();
  }, []);

  if (isLoading || isFetching) return <Loader />;
  if (error)
    return <Error message={error ? error.message : "Error Loading Blogs"} />;

  return (
    <div className="2xl:container w-full flex flex-col px-6 md:px-[70px]">
      <div className="flex flex-col gap-6 md:gap-10">
        {blogs?.data
          ?.slice()
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          .map((item, index) => (
            <div key={index}>
              <Link to={`/blog/${item.id}`}>
                <div className="grid grid-cols-[3fr_1fr] max-sm:place-items-center md:grid-cols-[2.3fr_1fr]">
                  <div className="text-left">
                    <div className="flex flex-col gap-3 md:gap-4 mb-4 sm:mb-8 w-[80%] md:w-10/12">
                      <p className="text-14 md:text-20 font-medium text-[#046353]">
                        {item.blog_title}
                      </p>
                      {/* <p className=" text-18 sm:text-20 md:text-36 font-[700] text-headingtext">
                      {`“${item.heading}”`}
                    </p> */}
                      <p className="text-16 text-[#41444B] hidden md:block">
                        {parse(
                          he.decode(
                            item.blog_content.length > 450
                              ? `${item.blog_content.slice(0, 450)}...`
                              : item.blog_content
                          )
                        )}
                        {/* {parse(he.decode(item.blog_content))} */}
                      </p>
                    </div>
                    <div className="hidden md:flex text-14 md:text-16 text-headingtext font-medium gap-10">
                      <p>{formatDisplayDate(item?.created_at)}</p>
                    </div>
                  </div>

                  <ImageWithSkeleton
                    src={item.blog_image_url}
                    alt="image"
                    containerClass=" w-[350px] h-[250px] rounded-[12px] min-w-[140px] min-h-[100px] lg:max-h-[250px] lg:max-w-[350px]"
                  />
                </div>
                <div className="md:hidden flex text-14 md:text-16 text-headingtext font-medium gap-10">
                  <p>{formatDisplayDate(item?.created_at)}</p>
                </div>
              </Link>

              {index !== blogs.data.length - 1 && (
                <hr className="h-[1px] mt-8 text-[#CED0D6]" />
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default Blog2;
